import styled from 'styled-components';
import { device } from '../../styles/devices';

export const H1 = styled.h1`
  font-size: 21px;
  font-weight: 700;
  line-height: 30px;
  @media ${device.tablet} {
    max-width: 100%;
    margin-bottom: 24px;
    font-size: 54px;
    line-height: 64px;
  }
  @media ${device.laptopL} {
    max-width: 75%;
  }
`;

export const Year = styled.div`
  display: inline-block;
  padding-right: 6px;
  @media ${device.tablet} {
    display: block;
    font-size: 36px;
  }
`;

export const ModelMake = styled.div`
  display: inline-block;
  @media ${device.tablet} {
    display: flex;
    font-weight: 700;
  }
`;

export const H2 = styled.h2`
  font-size: 13px;
  line-height: 30px;
  font-weight: 400;
  margin-bottom: ${({ usCPO }: { usCPO?: boolean }) => (usCPO ? '0' : '17px')};

  @media ${device.tablet} {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 0px;
    max-width: 95%;
  }

  @media ${device.laptopL} {
    max-width: 75%;
  }
`;

export const Mileage = styled.h3`
  font-size: 13px;
  line-height: 17px;
  font-weight: normal;
  margin-right: 18px;
  margin-bottom: 36px;
  @media ${device.tablet} {
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    letter-spacing: -0.3px;
    margin-right: 0px;
    margin-bottom: 0;
    margin-top: 10px;
  }
  @media ${device.laptopM} {
    margin-bottom: 24px;
  }
`;
